import { applyMiddleware, CombinedState, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk from 'redux-thunk';

import * as reducers from '../../reducers';
import { IApplicationState, TReduxActions, IReduxStore, IThunkContext } from '../../types/redux';

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 */
export function createReduxStore(
  initialState: Partial<IApplicationState>,
  debugEnabled: boolean,
  context: IThunkContext,
) {
  const rootReducer = combineReducers<IApplicationState, TReduxActions>(reducers);

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnhancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context))) as any; // eslint-disable-line

  const createStore = (): IReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IApplicationState, {}>(
      rootReducer,
      initialState,
      storeEnhancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(rootReducer);

    return storeReminder;
  }

  return createStore();
}
